import { useState } from 'react'
import { Package, ChevronDown, ArrowRight } from 'lucide-react'
import { OrderRow } from './heute-row'

const ORANGE = 'var(--accent-orange-strong)'
const ORANGE_TINT = 'color-mix(in srgb, var(--accent-orange-strong) 16%, transparent)'

// Versand-Zustand: ausklappbare Card mit offenen Bestellungen.
// Immer zugeklappt starten — Tap öffnet, zeigt max 2 + (bei >2) "Alle X ansehen".
export function VersandCard({ orders, count, onOpenStore, flat = false }) {
  const [open, setOpen] = useState(false)
  const expanded = open
  const showAllLink = count > 2

  const title = `${count} ${count === 1 ? 'Bestellung' : 'Bestellungen'} zu versenden`
  const sub = expanded ? 'Bereit zum Verpacken' : 'Tippen zum Anzeigen'

  // flat: ohne Karten-Chrome (transparent) — z. B. in der Dashboard-Uebersicht.
  const shell = flat ? '' : 'bg-[var(--bg-L1)] border border-[var(--border-subtle)] rounded-[20px] overflow-hidden'

  return (
    <div className={shell}>
      {/* Header */}
      <div
        onClick={() => setOpen(o => !o)}
        className="flex items-center gap-3 p-4 cursor-pointer active:opacity-90 transition-opacity"
      >
        <div
          className="w-[42px] h-[42px] rounded-xl flex items-center justify-center flex-shrink-0"
          style={{ background: ORANGE_TINT }}
        >
          <Package size={22} style={{ color: ORANGE }} />
        </div>
        <div className="min-w-0 flex-1">
          <div className="text-base font-medium">{title}</div>
          <div className="text-[13px] text-[var(--label-tertiary)] mt-px">{sub}</div>
        </div>
        <div
          className="flex items-center justify-center min-w-[26px] h-[26px] px-2 rounded-[13px] text-sm font-medium flex-shrink-0"
          style={{ background: ORANGE, color: 'var(--on-orange)' }}
        >
          {count}
        </div>
        <ChevronDown
          size={19}
          className="text-[var(--label-tertiary)] flex-shrink-0"
          style={{ transform: expanded ? 'rotate(180deg)' : 'none', transition: 'transform 200ms var(--ease-out-soft)' }}
        />
      </div>

      {/* Body: max 2 Bestellungen */}
      {expanded && orders.length > 0 && (
        <div>
          {orders.map((o, i) => (
            <div key={o.id ?? i}>
              <div className="h-px mx-4" style={{ background: 'var(--border-subtle)' }} />
              <OrderRow order={o} onClick={() => onOpenStore?.('online')} />
            </div>
          ))}
        </div>
      )}

      {/* "Alle X ansehen" — nur bei ≥3 */}
      {expanded && showAllLink && (
        <>
          <div className="h-px mx-4" style={{ background: 'var(--border-subtle)' }} />
          <div
            onClick={() => onOpenStore?.('online')}
            className="flex items-center justify-center gap-[7px] px-4 py-[14px] cursor-pointer active:opacity-90 transition-opacity"
          >
            <span className="text-sm font-medium" style={{ color: 'var(--accent-online)' }}>
              Alle {count} ansehen
            </span>
            <ArrowRight size={16} style={{ color: 'var(--accent-online)' }} />
          </div>
        </>
      )}
    </div>
  )
}
